import { Money } from '@betterment/core';

import { ClosedMarketHours } from './highlight-section/ClosedMarketHours';
import { PerformanceMultiDay } from './highlight-section/PerformanceMultiDay';
import { PerformanceSingleDayOpen } from './PerformanceSingleDayOpen';

import { DateRangeOption } from '../../../../../../graphql/schema';
import { type MarketScheduleType, isMarketScheduleOpen } from '../marketSchedule';
import { isDateRangeOptionToday } from '../timePeriods';

type PerformanceHighlightSectionType = {
  latestPriceAmount: Money;
  latestReturnsAmount: Money;
  latestReturnsPercentage: number;
  marketSchedule: MarketScheduleType;
  dateRangeOption: DateRangeOption;
  currentDate: Date;
};

export const PerformanceHighlightSection = ({
  latestPriceAmount,
  latestReturnsAmount,
  latestReturnsPercentage,
  marketSchedule,
  dateRangeOption,
  currentDate,
}: PerformanceHighlightSectionType) => {
  if (!isDateRangeOptionToday(dateRangeOption)) {
    return (
      <PerformanceMultiDay
        latestPriceAmount={latestPriceAmount}
        latestReturnsAmount={latestReturnsAmount}
        latestReturnsPercentage={latestReturnsPercentage}
        dateRangeOption={dateRangeOption}
      />
    );
  }

  if (isMarketScheduleOpen(marketSchedule)) {
    return (
      <PerformanceSingleDayOpen
        latestPriceAmount={latestPriceAmount}
        latestReturnsAmount={latestReturnsAmount}
        latestReturnsPercentage={latestReturnsPercentage}
        marketSchedule={marketSchedule}
        dateRangeOption={dateRangeOption}
        currentDate={currentDate}
      />
    );
  }

  return (
    <ClosedMarketHours
      currentDate={currentDate}
      latestPriceAmount={latestPriceAmount}
      marketSchedule={marketSchedule}
    />
  );
};
